import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

import { TableHeaderEntryModel, TableBodyEntryModel } from '@shared/models';
import { FormatDatesService, OverviewTableService   } from '@shared/services';
import { EmployeeDetails } from '@shared/factories';

@Component({
  selector:     'externals-table',
  styleUrls: ['./externals-table.component.sass'],
  templateUrl: '../../table-entries.component.html',
  host: { class: 'am-flex-column bg-white b-radius-wide overflow' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExternalsTableComponent {
  @Input() rows:         EmployeeDetails[];
  @Input() paginationId: string;
  @Input() loading:      boolean;

  @Output() headerCallback = new EventEmitter<any>();

  constructor(
    private overviewTableService: OverviewTableService
  ) {}

  headerCallbackHandler(res): void {
    this.headerCallback.emit(res);
  }

  getTableClass(): string {
    return 'externals-table';
  }

  getOptionalValue(field: string): boolean {
    return this[field] || null;
  }

  private preparePreload(): TableBodyEntryModel[] {
    return new Array<TableBodyEntryModel>(10).fill({
      cells: ([
        this.overviewTableService.getExternalEmployeeCellPlaceholder(),
        { xs_label: ' ', class: 'activated-cell', value: ' '                                 },
        this.overviewTableService.getLocationCellPlaceholder(),
        { xs_label: ' ', class: 'logged-cell',    value: ' '                                 },
        { xs_label: ' ', class: 'exit-cell',      value: ' '                                 },
        {                class: 'action-cell',    buttons: [{ class: 'action-cell-button' }] }
      ])
    });
  }

  prepareTableHeader(): TableHeaderEntryModel[] {
    return [
      { title: 'Mitarbeiter (Pers.Nr.)', class: 'name-cell',      sort_by: ['external_employee_last_name', 'external_employee_first_name'] },
      { title: 'Niederlassung',          class: 'location-cell',  sort_by: ['external_location_description']                               },
      { title: 'Aktiviert',              class: 'activated-cell', sort_by: ['activated_at']                                                },
      { title: 'Letzer Login',           class: 'logged-cell',    sort_by: ['last_login_at']                                               },
      { title: 'Eintrittsdatum',         class: 'entry-cell',     sort_by: ['entry_date']                                                  },
      { title: 'Austrittsdatum',         class: 'exit-cell',      sort_by: ['exit_date']                                                   },
      { title: 'Aktion',                 class: 'action-cell'                                                                              }
    ];
  }

  prepareTableBody(): TableBodyEntryModel[] {
    if (this.loading) return this.preparePreload();
    return this.rows.map((external: EmployeeDetails): TableBodyEntryModel => ({
      cells: [
        this.overviewTableService.getExternalEmployeeCell(external),
        { xs_label: 'Aktiviert',      class: 'activated-cell', value: FormatDatesService.formatDate(external.activatedAt) },
        this.overviewTableService.getLocationCell(external?.workLocation),
        { xs_label: 'Letzer Login',   class: 'logged-cell',    value: FormatDatesService.formatDate(external.lastLoginAt) },
        { xs_label: 'Eintrittsdatum', class: 'entry-cell',     value: FormatDatesService.formatDate(external.entryDate)   },
        { xs_label: 'Austrittsdatum', class: 'exit-cell',      value: FormatDatesService.formatDate(external.exitDate)    },
        { xs_label: null,             class: 'action-cell',
          buttons: [
            { class: 'action-cell-button',
              label: 'Ansehen',
              routerLink: [`/time-tracking/ee-details/${external.id}`]
            }
          ]
        }
      ]
    }));
  }

}
